<div class="login-container">
    <div class="card-container">
        <div class="login-card">
            <img src="../../../../assets/images/AllyLogoDark.svg" alt="AndDone Ally" class="anddone-logo" />
            <h5>
                {{ "login.login" | translate }}
            </h5>
            <form [formGroup]="loginForm">
                <div class="input-container">
                    <label for="loginUsername">
                        <span class="required">*</span> {{ "login.userName" | translate }}
                    </label>
                    <input type="text" id="loginUsername" placeholder="Username" formControlName="userName" />
                    <span class="error-text">{{ loginFormErrors.userName }}</span>
                </div>

                <div class="input-container">
                    <label for="loginPassword">
                        <span class="required">*</span>
                        {{ "login.password" | translate }}
                    </label>
                    <input [type]="passwordFieldType" id="loginPassword" placeholder="Password"
                        formControlName="password" (keyup)="triggerInput($event)" />
                    <i class="bi"
                        [ngClass]="passwordFieldType === 'password' ? 'bi-eye-slash hide-password' : 'bi-eye show-password'"
                        (click)="onTogglePassword()" tabindex="0" (keydown.enter)="onTogglePassword()"></i>
                    <span class="error-text">{{ loginFormErrors.password }}</span>
                </div>

                <div class="checkbox-container">
                    <input type="checkbox" name="RememberMe" id="rememberLogin" formControlName="rememberMe" />
                    <label for="rememberLogin">{{
                        "login.remeberMe" | translate
                        }}</label>
                </div>

                <a class="password-link" (click)="forgotPassword()">
                    {{ "login.forgotPassword" | translate }}
                </a>
                <a class="button button-green" id="login-button" (click)="login()"
                    [ngStyle]="{ 'pointer-events': isLoader() ? 'none' : '' }">
                    <span>
                        @if (isLoader()) {
                        <span class="spinner-border spinner-border-sm"></span>
                        }
                        <span class="m-3">{{ "login.login" | translate }}</span>
                    </span>
                </a>
            </form>
        </div>
        <div class="login-footer">
            <span>{{'footer.copyrightText1'|translate}} {{currentYear}} {{'footer.copyrightText2'|translate}}</span>
            <a (click)="goToLink(appSetting.privacyPolicyUrl)"
                target="currentwindow1">{{'footer.privacyStatement'|translate}}</a>
            <a (click)="goToLink(appSetting.termsOfUseUrl)"
                target="currentwindow2">{{'footer.termsOfService'|translate}}</a>
        </div>
    </div>
</div>